import React, { FC, useEffect, useState } from 'react';
import { PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { IModalWindow, ModalWindow } from '../../components/modal/ModalWindow';
import { fetchAgencyList } from '../../store/merchnts/actions/agents';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { AddNewAgency } from '../../components/agents/AddNewAgency';
import { IAgency } from '../../constants/new-agency/new-agency-form';
import { salesAgenciesBreadCrumbs } from './CommissionsPage';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../../components/table/Table';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { parseSearchParams } from '../../utils/utilities';
import { SalesAgenciesListFilters } from '../../components/agents/SalesAgenciesListFilters';
// import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SalesAgenciesList: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { pathname, search } = useLocation();

	const filtersFromUrl = parseSearchParams(search) || {};

	const { merchantState: { agenciesList, isAgenciesListLoading }, dispatch } = useMerchants();

	const [searchValue, setSearchValue] = useState<string>(filtersFromUrl?.query ?? '');
	const [isAddAgencyModalOpen, setIsAddAgencyModalOpen] = useState<boolean>(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const [chosenAgency, setChosenAgency] = useState<IAgency | null>(null);

	const handleEdit = (agency: IAgency): void => {
		setChosenAgency(agency);
		setIsAddAgencyModalOpen(true);
	};

	useEffect(() => {
		void fetchAgencyList(dispatch);
	}, []);

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	const handleSuccess = (): void => {
		setIsAddAgencyModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: chosenAgency?.id ? t('AGENCY.MODAL_TITLE_EDIT') : t('AGENCY.MODAL_TITLE'),
			content: (
				<div className="fs-6">
					{t('AGENCY.SUCCESS_MODAL_TEXT')}
				</div>
			),
			confirmButtonText: t('AGENCY.SUCCESS_BTN_NAME'),
			minHeight: 100,
			onConfirm: closeModal,
			onClose: closeModal
		});
	};

	const handleError = (): void => {
		setIsAddAgencyModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: chosenAgency?.id ? t('AGENCY.MODAL_TITLE_EDIT') : t('AGENCY.MODAL_TITLE'),
			content: (
				<div className="fs-6">
					{t('AGENCY.FAIL_MODAL_TEXT')}
				</div>
			),
			confirmButtonText: t('AGENCY.FAIL_BTN_NAME'),
			minHeight: 100,
			onConfirm: () => {
				closeModal();
				setIsAddAgencyModalOpen(true);
			},
			onClose: closeModal
		});
	};

	const filteredList = (): IAgency[] => {
		if (searchValue) {
			return agenciesList?.filter(({ id, name }) => (
				id?.toLowerCase()?.includes(searchValue?.trim()?.toLowerCase())
				|| name?.toLowerCase()?.includes(searchValue?.trim()?.toLowerCase())
			));
		} else {
			return agenciesList;
		}
	};

	const closeNewAgencyModal = (): void => {
		setIsAddAgencyModalOpen(false);
		setChosenAgency(null);
	};

	const rowActions = (rowData): JSX.Element => {
		return (
			<div className="d-flex align-items-center justify-content-end">
				<div
					className="text-muted d-flex align-items-center justify-content-center fw-bolder fs-7"
					onClick={(): void => handleEdit(rowData?.original)}
				>
					<span
						className="cursor-pointer me-5"
						onClick={(): void => navigate(`${pathname}/${rowData?.original?.id}`, { state: { search }})}
					>
						View
					</span>

					<div className="d-flex align-items-center cursor-pointer">
						{/*<FontAwesomeIcon icon={faPenToSquare} className="edit-icon me-1"/>*/}
						<span>Edit</span>
					</div>

				</div>
			</div>
		);
	};

	return (
		<>
			<PageTitle breadcrumbs={salesAgenciesBreadCrumbs}>{t('MENU.AGENCY')}</PageTitle>

			<SalesAgenciesListFilters
				query={searchValue}
				setQuery={setSearchValue}
				setIsAddAgencyModalOpen={setIsAddAgencyModalOpen}
			/>

			<div className="card">
				<div className="card-body">
					<Table
						name={TablesNames.salesAgenciesTableData}
						data={filteredList()}
						isLoading={isAgenciesListLoading}
						enableRowActions={true}
						rowActions={rowActions}
						actionColumnsSize={50}
						actionColumnAlign='right'
						positionActionsColumn='last'
						enableColumnResizing={false}
						enableDensityToggle={false}
						enableHiding={false}
						enableBottomToolbar={false}
						enableColumnActions={false}
						// queryParamsListener={listener}
					/>
				</div>
			</div>

			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
			<ModalWindow
				isOpen={isAddAgencyModalOpen}
				backdrop="static"
				onClose={closeNewAgencyModal}
				modalTitle={chosenAgency?.id ? t('AGENCY.MODAL_TITLE_EDIT') : t('AGENCY.MODAL_TITLE')}
				minHeight={150}
				content={
					<AddNewAgency
						onCancel={closeNewAgencyModal}
						setChosenAgency={setChosenAgency}
						agency={chosenAgency}
						onSuccess={handleSuccess}
						onError={handleError}
					/>
				}
			/>

		</>
	);
};
